import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import "./Pagenotfound.css"
import page from "./../../images/404.png"
import { Link } from 'react-router-dom';
import useNavigation from "../../utils/Navigation";


function Pagenotfound() {
  const navigateToSection = useNavigation()
  return (
    <>
      <Header />
        <section className="pagenotfound">
          <div className="container">
              <img src={page} alt=""/>
              <h3>Page not Found!</h3>
              <p>The page you are looking for doesn't exist. Please return to the website's homepage to find what you're looking for.</p>
              <Link to="/" alt="Home"><button className="continue">Return to home page</button></Link>
          </div>
        </section>
        <section className="goal bg_green no_bg">
        <div className="container">
          <div className="faq">
            <h4>Explore FAQs to learn more about the clinical trial</h4>
            <Link to="/faqs" alt="faqs"><button className="explore">Explore</button></Link>
          </div>
        </div>
      </section>
      <Link to = "/#eligibility"  onClick={() => navigateToSection('eligibility')} alt="sticky button"><button className="sticky_eligibility">See if you qualify</button></Link>
      <Footer />
    </>
  );
}

export default Pagenotfound;